export default {
  title: {
    presence: { allowEmpty: false, message: '请填写WIFI名称' }
  },
  remark: {
    presence: { allowEmpty: false, message: '请填写WIFI备注' }
  }
};
